import React from 'react';

import { Stack } from '@mantine/core';
import SimpleHeader from 'layouts/MobileLayout/components/SimpleHeader';
import AccountingCard from 'pages/private/owner/Dashboard/components/AccountingCard';
import AthleteAttendanceCard from 'pages/private/owner/Dashboard/components/AthleteAttendanceCard';
import AthleteBirthdaysCard from 'pages/private/owner/Dashboard/components/AthleteBirthdaysCard';
import AthletesCard from 'pages/private/owner/Dashboard/components/AthletesCard';
import BusinessMetricsCard from 'pages/private/owner/Dashboard/components/BusinessMetricsCard';
import PaymentsCard from 'pages/private/owner/Dashboard/components/PaymentsCard';
import ReservationCard from 'pages/private/owner/Dashboard/components/ReservationCard';
import UtilizationCard from 'pages/private/owner/Dashboard/components/UtilizationCard';

const Dashboard = (): JSX.Element => {
  return (
    <>
      <SimpleHeader title='Dashboard' />

      <Stack className='content'>
        <BusinessMetricsCard />

        <AccountingCard />

        <PaymentsCard />

        <AthletesCard />

        <UtilizationCard />

        <ReservationCard />

        <AthleteAttendanceCard />

        <AthleteBirthdaysCard />
      </Stack>
    </>
  );
};

export default Dashboard;
